export const changeLocale = locale => ({
  type: 'CHANGE_LOCALE',
  payload: { locale },
});
